<template>
  <div class="contract_management">

    <van-sticky>
      <van-nav-bar title="合同管理" left-arrow @click-left="goback()" />
    </van-sticky>

    <van-pull-refresh v-model="refreshing" success-text="刷新成功" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :immediate-check="false">
        <div class="management_list" v-for="(item, index) in employeeList" :key="index">
          <div class="list_item">
            <div class="item_detail">
              <div class="lin2 fs16 font-weightbold color000">{{ item.site_name }}</div>
              <div> 订单编号：{{ item.order_info_orderNumber }}</div>
              <div>签约时间：{{ item.signTime }}</div>
              <div>订单状态：{{ item.order_info_status_name }}</div>
              <div>有效期剩余时间：{{ item.daysRemaining }}天</div>
            </div>
            <div class="item_btn">
              <div @click="onContractBrowse(item.order_info_id)">预览</div>
              <div style=" background: blue;" class="tag-read" :data-clipboard-text="url"
                v-if="url != '' && index === activeIndex">复制</div>
              <div @click="orderInfoUserH5DownloadZip(item.order_info_id, index)" v-else>下载</div>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>



  </div>
</template>

<script>
import { NavBar, List, PullRefresh } from "vant";
import Clipboard from 'clipboard';

export default {
  components: {
    [NavBar.name]: NavBar,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
  },
  data() {
    return {
      params: {
        keyword: "",
        page: 1,
        size: 8,
      },
      //员工列表
      employeeList: [],
      loading: false, //底部加载状态
      finished: false, //底部是否完成状态
      refreshing: false,
      url: '',
      activeIndex: -1,
    };
  },

  created() {
    // 员工管理-列表
    this.employeeManagementList();
  },

  methods: {
    //返回上一页
    goback() {
      if (window.history.length <= 1) {
        this.$router.push({ path: "/" });
        return false;
      } else {
        this.$router.go(-1);
      }
    },

    //下拉刷新
    onRefresh() {
      var that = this;
      setTimeout(() => {
        that.params.page = 1;
        // 员工管理-列表
        that.employeeManagementList();
        that.refreshing = false;
        that.finished = false;
      }, 1000);
    },

    //上拉加载
    onLoad() {
      var that = this;
      setTimeout(() => {
        that.employeeManagementList();
      }, 1000);
    },

    // 员工管理-列表
    employeeManagementList() {
      var that = this;
      that.$api
        .contractListBySiteSupplierIdAPI(that.params)
        .then(function (res) {
          if (res.data.code === 200) {
            // 如果是第一次进入页面page==1 直接赋值
            if (that.params.page === 1) {
              that.employeeList = res.data.dataList;
            } else {
              that.employeeList = [...that.employeeList, ...res.data.dataList];
            }

            // 当还有数据是page++
            if (res.data.dataList.length > 0) {
              that.params.page++;
              that.loading = false;
            } else {
              // 如果没有数据加载完毕
              that.finished = true;
            }
          }
        })
        .catch(function (err) {
          console.log("error");
        });
    },

    //点击跳转合同浏览页面
    onContractBrowse(id) {
      this.$router.push({ path: "/order/contractBrowse", query: { id: id } });
    },

    //订单-下载合同
    orderInfoUserH5DownloadZip(id, index) {
      var that = this;
      var params = {
        order_info_id: id,
      };
      that.$api
        .orderInfoUserH5DownloadZipAPI(params)
        .then(function (res) {
          if (res.data.code === 200) {
            that.url = res.data.data;
            that.activeIndex = index;
            setTimeout(function () {
              let clipboard = new Clipboard('.tag-read')
              clipboard.on('success', e => {
                console.log('复制成功')
                that.$Notify({
                  message: "复制成功",
                  type: "success",
                });
                // 释放内存
                clipboard.destroy()
              })
              clipboard.on('error', e => {
                // 不支持复制
                console.log('该浏览器不支持自动复制')

                that.$Notify({
                  message: "该浏览器不支持自动复制",
                  type: "error",
                });
                // 释放内存
                clipboard.destroy()
              })

            }, 500);
          } else {
            that.$Notify({
              message: res.data.message,
              type: "warning",
            });
          }
        })
        .catch(function (err) {
          console.log("error");
        });
    },
  },
};
</script>

<style lang="less" scoped>
.contract_management {
  .management_list {
    display: flex;
    flex-direction: column;
    margin: 0px 15px;
    padding: 15px 0px;
    border-bottom: 1px solid #f3f3f3;

    .list_item {
      display: flex;
      justify-content: space-between;

      .item_detail {
        display: flex;
        font-size: 13px;
        color: #666;
        flex-direction: column;
        width: 80%;

        div {
          margin-top: 5px;
        }
      }

      .item_btn {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        font-size: 14px;
        color: #fff;
        height: 90px;

        div {
          border-radius: 5px;
          padding: 2px 8px;
        }

        div:nth-child(1) {
          background: #fc0c30;
        }

        div:nth-child(2) {
          background: #0cadfc;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/personal/contractManagement.vue